import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageerror: null,
  pagesuccess: null,
  otp: null,
  timer: 90,
  otperror: false,
  showAadharBtn: false,
};

const ckycOtpInputSlice = createSlice({
  name: 'ckycOtpInput',
  initialState,
  reducers: {
    setPageError: (state, action) => {
      state.pageerror = action.payload;
    },
    setPageSuccess: (state, action) => {
      state.pagesuccess = action.payload;
    },
    setTimer: (state, action) => {
      state.timer = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setOtpError: (state, action) => {
      state.otperror = action.payload;
    },
    setShowAadharBtn: (state, action) => {
      state.showAadharBtn = action.payload;
    },
  },
});

export const {
  setPageError,
  setPageSuccess,
  setTimer,
  setOtp,
  setOtpError,
  setShowAadharBtn,
} = ckycOtpInputSlice.actions;

export default ckycOtpInputSlice.reducer;
